import { render, staticRenderFns } from "./statistics-search-results.vue?vue&type=template&id=28083346&scoped=true"
import script from "./statistics-search-results.vue?vue&type=script&lang=js"
export * from "./statistics-search-results.vue?vue&type=script&lang=js"
import style0 from "./statistics-search-results.vue?vue&type=style&index=0&id=28083346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28083346",
  null
  
)

/* custom blocks */
import block0 from "./statistics-search-results.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports